<article class="related-search sim-gallery pt-5">
  <div class="container">
    <div
      *ngIf="shimmerType != 'search'"
      class="simmer-animation sim-heading"
    ></div>
    <div class="row custome-set pb-3">
      <div class="series-box" *ngFor="let grid of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]">
        <div class="simmer-animation series-img"></div>
        <div class="series-content">
          <div class="simmer-animation w-100 simmer-animation sim-date"></div>
        </div>
      </div>
    </div>
  </div>
</article>
